<template>
  <div class="home">
    <div class="hero">
      <img v-if="userAvatar" :src="userAvatar" class="hero-avatar" />
      <h1>📖 {{ userName || 'ТИМУРКА' }} ЧИТАЕТ</h1>
      <p class="subtitle">Тренажёр для чтения слогов и слов</p>
      <div v-if="totalStars > 0" class="hero-stars">
        <span class="hero-star-icon">⭐</span>
        <span class="hero-star-count">{{ totalStars }}</span>
      </div>
    </div>

    <div class="cards">
      <router-link to="/syllables" class="card card-syllables">
        <div class="card-icon">🔤</div>
        <div class="card-title">Слоги</div>
        <div class="card-desc">Учимся читать слоги — взрослый проверяет</div>
      </router-link>

      <router-link to="/words" class="card card-words">
        <div class="card-icon">📝</div>
        <div class="card-title">Слова</div>
        <div class="card-desc">Читаем слова по слогам</div>
      </router-link>
    </div>

    <div class="bottom-link">
      <router-link to="/stats">Статистика</router-link>
      <span class="sep">·</span>
      <router-link to="/syllable-map">Карта слогов</router-link>
    </div>
  </div>
</template>

<script setup>
import { useUserProfile } from '../composables/useUserProfile.js'

const { userName, userAvatar, totalStars } = useUserProfile()
</script>

<style scoped>
.home {
  max-width: 700px;
  margin: 0 auto;
  text-align: center;
}

.hero {
  margin-bottom: 40px;
}

.hero-avatar {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid #e0e0e0;
  margin-bottom: 12px;
}

h1 {
  font-size: 36px;
  color: #2c3e50;
  margin-bottom: 8px;
}

.subtitle {
  font-size: 18px;
  color: #7f8c8d;
}

.hero-stars {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 16px;
  background: linear-gradient(135deg, #fff9c4, #ffe082);
  padding: 6px 20px;
  border-radius: 24px;
  box-shadow: 0 4px 16px rgba(255, 193, 7, 0.35);
  animation: heroStarsIn 0.6s ease;
}

.hero-star-icon {
  font-size: 24px;
  animation: heroStarPulse 2s ease infinite;
}

.hero-star-count {
  font-size: 22px;
  font-weight: 900;
  color: #e65100;
}

@keyframes heroStarsIn {
  0% { transform: scale(0) rotate(-10deg); opacity: 0; }
  60% { transform: scale(1.15) rotate(3deg); }
  100% { transform: scale(1) rotate(0deg); opacity: 1; }
}

@keyframes heroStarPulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.2); }
}

.cards {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.card {
  display: block;
  padding: 24px;
  border-radius: 16px;
  text-decoration: none;
  color: white;
  transition: transform 0.2s, box-shadow 0.2s;
  text-align: left;
}

.card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

.card-syllables {
  background: linear-gradient(135deg, #42b883, #369970);
}

.card-words {
  background: linear-gradient(135deg, #e74c3c, #c0392b);
}

.card-icon {
  font-size: 40px;
  margin-bottom: 8px;
}

.card-title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 4px;
}

.card-desc {
  font-size: 14px;
  opacity: 0.9;
}

.bottom-link {
  margin-top: 40px;
  display: flex;
  gap: 8px;
  justify-content: center;
  align-items: center;
}

.sep {
  color: #ddd;
}

.bottom-link a {
  color: #bbb;
  text-decoration: none;
  font-size: 14px;
}

.bottom-link a:hover {
  color: #888;
}
</style>
